module.exports = __webpack_public_path__ + "static/img/reference pics_cgu university1.b47a6d4e.jpg";